import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

export default function Preloader({ onDone }) {
  const [gone, setGone] = useState(false);

  useEffect(() => {
    // Fast launch — fade the veil once the initial paint is on screen.
    const t = setTimeout(() => {
      setGone(true);
      onDone?.();
    }, 350);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <AnimatePresence>
      {!gone && (
        <motion.div
          data-testid="preloader"
          className="fixed inset-0 z-[200] flex items-center justify-center bg-[#050505]"
          exit={{ opacity: 0 }}
          transition={{ duration: 0.35, ease: EASE }}
        >
          <motion.img
            src="/keilani-logo-white.png"
            alt="Keilani Clothing"
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, ease: EASE }}
            className="h-6 w-auto md:h-8"
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
